// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfse from './selecao_todos_nfse';
import { Input } from '../../../../../../common/input';

export default function CamposServico() {
  return (
    <FormSection name="servico">
      <SelecaoTodosNfse nomes={ ["servico"] } titulo="Dados do Serviço"/>

      <div className="grupo-checkbox">
        <Input name="valor" label="Valor" checkbox/>
        <Input name="cargaTributariaValor" label="Carga Tributária" checkbox/>
        <Input name="tributacao" label="Tributação" checkbox/>
        <Input name="valorDeducoes" label="Deduções" checkbox/>
        <Input name="servicoCodigo" label="Código Serviço" checkbox/>
        <Input name="aliquota" label="Alíquota" checkbox/>
        <Input name="valorIss" label="Valor ISS" checkbox/>
        <Input name="valorCredito" label="Valor Crédito" checkbox/>
        <Input name="issRetido" label="ISS Retido" checkbox/>
      </div>
    </FormSection>
  );
}
